import React, { useEffect, useState } from "react";
import { Col, Container, Modal, Row } from "react-bootstrap";
import { useTranslation, Trans } from "react-i18next";
import {
  ActionIconContainer,
  AddFormButton,
  CustomLoader,
  FilterButton,
  GreenButton,
} from "../../../shared/components/TableElements";
import { useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import { Controller, get, useForm } from "react-hook-form";
import { Card, CardBody } from "../../../shared/components/Card";
import Error from "@/shared/components/form/Error";
import {
  FormContainer,
  FormGroupLabel,
  FormHeading,
  FormItem,
  HintText,
} from "../../../shared/components/form/FormElements";
import { formInputStyles, formStyles } from "../../../shared/constants/styles";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import {
  convertToDays,
  CustomInput,
  Desc,
  DueOnWrap,
  NotifyMeWrap,
  TimeSelect,
} from "../MaintenanceReminders/MaintenanceRemindersForm";
import {
  convertToTextDate,
  getDateFnsLocale,
  getUserDocUrl,
  handleNegative,
  handleNumberInputOnWheelPreventChange,
} from "../../../shared/helpers";
import SubscribeTooltipIcon from "../../../shared/components/SubscribeTooltipIcon";
import { useAuth } from "../../../contexts/AuthContext";
import FormField from "../../../shared/components/form/FormField";
import {
  colorBackgroundBody,
  colorLightGray,
  colorLightYellow,
  colorYellowNew,
} from "../../../utils/palette";
import MarkDocumentRenewedPopup from "./components/MarkDocumentRenewedPopup";
import getUnixTime from "date-fns/getUnixTime";
import { s3Url } from "../../../shared/constants";
import { postApi } from "../../../api/getUser";
import ErrorPopup from "../../../shared/components/ErrorPopup";
import { addMsg } from "../../../features/snackbar/snackbarSlice";
import { useDispatch } from "react-redux";
import CustomMenuList from "../../../shared/components/form/CustomMenuList";
import CreateDocNamePopup from "./components/CreateDocNamePopup";

const DocumentRenewalsFormPopup = ({
  showPopup,
  setShowPopup,
  type,
  rowData,
  setSnackbarMsg,
}) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const { tag, setReload } = useAuth();
  const { userId, roleId } = useSelector((state) => state.user);

  const {
    handleSubmit,
    reset,
    register,
    control,
    watch,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm();

  console.log("rowData", rowData);

  const [showMarkAsRenewedPopup, setShowMarkAsRenewedPopup] = useState(false);

  const user = watch("user");
  const document = watch("document");
  const expiryDate = watch("expiryDate");
  const notifyMeDuration = watch("notifyMeDuration");
  const notifyMePeriod = watch("notifyMePeriod");
  const userEmail = watch("userEmail");
  const notes = watch("notes");

  const [saveBtnLoading, setSaveBtnLoading] = useState(false);
  const [showErrPopup, setShowErrPopup] = useState(false);

  const [docsList, setDocsList] = useState([
    // {
    //   label: "Document 1",
    //   value: "document1",
    //   url: "https://s3.us-east-2.amazonaws.com/simplyfleet.app/image_data/org_21465/user_21465_1703848538184/Documents/new doc.pdf",
    // },
    // {
    //   label: "Document 2",
    //   value: "document2",
    //   url: "https://s3.us-east-2.amazonaws.com/simplyfleet.app/image_data/org_21465/user_21465_1703848538184/Documents/new doc 2.pdf",
    // },
    // {
    //   label: "Document 3",
    //   value: "document3",
    //   url: "",
    // },
  ]);

  //To show in preview
  const [notifyMeDate, setNotifyMeDate] = useState(null);

  const users = useSelector((state) => state.users.list);

  const activeUsers = users?.filter((u) => u.user_active);

  const [showCreateDocNamePopup, setShowCreateDocNamePopup] = useState(false);
  const [docNamePopupErr, setDocNamePopupErr] = useState("");

  const handleClose = () => {
    setShowPopup(false);
  };

  //Initial Effect
  useEffect(() => {
    if (type !== "edit") {
      setValue("notifyMePeriod", "days");
    }
  }, []);

  //Set user to logged in technician in tech login
  useEffect(() => {
    if (users?.length > 0 && roleId === 4 && type !== "edit") {
      const loggedInUser = users.find((u) => u.user_id === userId);
      setValue("user", loggedInUser);
    }
  }, [users, roleId]);

  //Effect to update docs list when user changes
  useEffect(() => {
    if (user) {
      (async () => {
        let userDocs = [];

        //if type is edit, push the selected record to userDocs list
        if (type === "edit") {
          const { document_name, s3_url, driver_visible } = rowData;
          userDocs.push({
            label: document_name,
            value: document_name,
            url: s3_url || "",
            visible: driver_visible,
          });
        }

        //Get documents from doc renewals
        const apiData = {
          querystring: "get_doc_renewals_by_user",
          user_id: user.user_id,
        };
        const response = await postApi(apiData, "commonNew");
        let docNamesWithExistingRenewals = [];
        if (response?.success) {
          const { user_data } = response;
          if (user_data?.length > 0) {
            docNamesWithExistingRenewals = user_data.map((doc) => {
              return doc.document_name?.toLocaleLowerCase();
            });
          }
        }

        if (user.additional_documents) {
          const userDocsObj = JSON.parse(user.additional_documents);
          const allDocsArr = userDocsObj["All_Documents"];
          if (allDocsArr.length > 0) {
            for (let doc of allDocsArr) {
              const [[key, value]] = Object.entries(doc);
              //only show docs that dont have existing renewals
              if (
                !docNamesWithExistingRenewals.includes(key?.toLocaleLowerCase())
              ) {
                const { items, image, visible } = value;
                let isVisible = +visible;

                if (typeof visible === "object") {
                  isVisible = +visible[0];
                }

                const { url, extension } = await getUserDocUrl(
                  user.org_id,
                  user.user_id,
                  key,
                  image
                );
                let s3Url =
                  extension === "txt"
                    ? ""
                    : `user_${user?.user_id}/Documents/${key}.${extension}`;
                userDocs.push({
                  label: key,
                  value: key,
                  url: s3Url,
                  visible: isVisible,
                });
              }
            }
          }
        }
        setDocsList(userDocs);
      })();
    }
  }, [user, type, rowData]);

  //Effect to update values on edit

  useEffect(() => {
    if (type === "edit" && users?.length > 0) {
      const {
        document_name,
        s3_url,
        driver_visible,
        user_id,
        start_date,
        due_on_date,
        emails,
        days_threshold,
        notes,
      } = rowData;
      setValue(
        "user",
        users.find((u) => u.user_id === rowData.user_id)
      );

      setValue("document", {
        label: document_name,
        value: document_name,
        url: s3_url,
        visible: driver_visible,
      });

      setValue("expiryDate", new Date(due_on_date * 1000));
      setValue("notifyMeDuration", days_threshold || "");
      setValue("notifyMePeriod", "days");

      //Emails
      if (emails) {
        const userEmails = emails.split(":::");
        if (userEmails.length > 0) {
          let temp = [];
          users.forEach((user) => {
            if (userEmails.includes(user.email)) {
              temp.push(user);
            }
          });
          setValue("userEmail", temp);
        }
      }

      setValue("notes", notes || "");
    }
  }, [type, rowData, users]);

  //Effect to set notifyMeDate - expiryDate -  notifyMeDuration
  useEffect(() => {
    let notifyBy = null;
    if (expiryDate && notifyMeDuration && notifyMePeriod) {
      notifyBy = new Date(expiryDate);
      notifyBy.setDate(
        notifyBy.getDate() - convertToDays(+notifyMeDuration, notifyMePeriod)
      );
    }

    setNotifyMeDate(notifyBy);
  }, [expiryDate, notifyMeDuration, notifyMePeriod]);

  const handleCreateNewDoc = (value) => {
    let newDocName = value?.trim();
    setDocsList((prev) => {
      let temp = [...prev];
      const existingDocNames = temp.map((doc) =>
        doc.label?.toLocaleLowerCase()
      );
      if (existingDocNames.includes(newDocName?.toLocaleLowerCase())) {
        setError("document", {
          type: "custom",
          message: t("doc_name_already_exists"),
        });
        return prev;
      } else {
        clearErrors("document");
        const newDocValue = {
          label: newDocName,
          value: newDocName,
          url: "",
          visible: 1,
        };
        setValue("document", newDocValue);
        temp.push(newDocValue);
        return temp;
      }
    });
  };

  const handleCreateDocNameFromPopup = (value) => {
    let newDocName = value?.trim();
    setDocsList((prev) => {
      let temp = [...prev];
      const existingDocNames = temp.map((doc) =>
        doc.label?.toLocaleLowerCase()
      );
      if (existingDocNames.includes(newDocName?.toLocaleLowerCase())) {
        setDocNamePopupErr(t("doc_name_already_exists"));
        return prev;
      } else {
        setDocNamePopupErr("");
        const newDocValue = {
          label: newDocName,
          value: newDocName,
          url: "",
          visible: 1,
        };
        setValue("document", newDocValue);
        temp.push(newDocValue);
        return temp;
      }
    });
    setShowCreateDocNamePopup(false);
  };

  const handleMarkAsRenewed = () => {
    setShowMarkAsRenewedPopup(true);
  };

  // const validateMaxNotifyMeOT = (v) => {
  //   if (v) {
  //     const notifyMeDate = new Date(expiryDate);
  //     notifyMeDate.setDate(
  //       notifyMeDate.getDate() - convertToDays(v, notifyMePeriod)
  //     );
  //     return notifyMeDate > new Date();
  //   } else {
  //     return true;
  //   }
  // };

  const validateMaxNotifyMe = (notifyMeInDays) => {
    if (notifyMeInDays) {
      const notifyMeDate = new Date(expiryDate);
      notifyMeDate.setDate(notifyMeDate.getDate() - notifyMeInDays);
      return notifyMeDate > new Date();
    } else {
      return true;
    }
  };

  const addReminder = async () => {
    try {
      if (!expiryDate) {
        setError(
          "expiryDate",
          {
            type: "required",
            message: t("required_err"),
          },
          { shouldFocus: true }
        );
        return;
      } else {
        clearErrors("expiryDate");
      }
      setSaveBtnLoading(true);

      const docRenewalId =
        type === "edit"
          ? rowData?.doc_renewal_id
          : `${user?.user_id}_${Date.now()}`;

      const dueOnDateVal = expiryDate ? getUnixTime(expiryDate) : 0;

      const daysThreshold = notifyMeDuration
        ? convertToDays(notifyMeDuration, notifyMePeriod)
        : 0;

      if (daysThreshold > 0) {
        const notifyMeCheck = validateMaxNotifyMe(daysThreshold);
        if (!notifyMeCheck) {
          setSaveBtnLoading(false);
          setError("notifyMeDuration", {
            type: "maxValue",
            message: t("less_than_current_date_err"),
          });
          return;
        } else {
          clearErrors("notifyMeDuration");
        }
      }

      let emailRecipients = "";
      if (userEmail) {
        userEmail.forEach((item) => {
          emailRecipients += item.email + ":::";
        });
      }
      emailRecipients = emailRecipients.slice(0, emailRecipients.length - 3);

      let startDate =
        type === "edit" ? rowData.start_date : getUnixTime(new Date());

      if (type === "edit" && +rowData.due_on_date !== +dueOnDateVal) {
        startDate = getUnixTime(new Date());
      }

      const docRenewals = [
        {
          doc_renewal_id: docRenewalId,
          user_id: user?.user_id,
          document_name: document.label,
          due_on_date: dueOnDateVal,
          days_threshold: daysThreshold,
          emails: emailRecipients,
          notes: notes || "",
          s3_url: document.url || "",
          action: type === "edit" ? 2 : 1,
          start_date: startDate,
          driver_visible: document.visible,
        },
      ];

      const apiData = {
        source: "web",
        querystring: "add-document-renewal",
        doc_renewals: docRenewals,
      };

      const docRenewalRes = await postApi(apiData, "commonNew");

      if (!docRenewalRes.success) {
        setSaveBtnLoading(false);
        setShowErrPopup(true);
        return;
      }

      const snackbarMsg =
        type === "edit"
          ? t("record_edited_msg", { recordName: t("user_renewal") })
          : t("record_added_msg", { recordName: t("user_renewal") });

      if (docRenewalRes?.success) {
        setReload("documentrenewals");
        setSaveBtnLoading(false);
        setShowPopup(false);
        dispatch(addMsg(snackbarMsg));
        //setSnackbarMsg(snackbarMsg);
      }
    } catch (err) {
      console.log(err);
      setSaveBtnLoading(false);
      setShowErrPopup(true);
      return;
    }
  };

  return (
    <>
      {showCreateDocNamePopup && (
        <CreateDocNamePopup
          show={showCreateDocNamePopup}
          onClose={() => {
            setDocNamePopupErr("");
            setShowCreateDocNamePopup(false);
          }}
          onAddDocName={handleCreateDocNameFromPopup}
          docNamePopupErr={docNamePopupErr}
        />
      )}
      {showErrPopup && (
        <ErrorPopup showPopup={showErrPopup} setShowPopup={setShowErrPopup} />
      )}
      {showMarkAsRenewedPopup && (
        <MarkDocumentRenewedPopup
          showPopup={showMarkAsRenewedPopup}
          setShowPopup={setShowMarkAsRenewedPopup}
          rowData={rowData}
          setShowDocRenewalFormPopup={setShowPopup}
          setShowErrPopup={setShowErrPopup}
        />
      )}
      <Modal show={showPopup} onHide={handleClose} size="xl">
        <Modal.Header>
          <h4>
            {type === "edit" ? t("edit_user_renewal") : t("add_user_renewal")}
          </h4>
          <div className="d-flex justify-content-end">
            <ActionIconContainer onClick={handleClose}>
              <i className="fi fi-rr-cross-small" />
            </ActionIconContainer>
          </div>
        </Modal.Header>
        <Modal.Body
          style={{ background: colorBackgroundBody }}
          className="m-0 p-0"
        >
          <FormContainer className="m-0 p-0">
            <Container className="m-0 p-0">
              <Row>
                <Col
                  md={user && document ? 8 : 12}
                  style={{
                    paddingRight: user && document ? "0" : "12px",
                  }}
                >
                  <Card className="m-0">
                    <CardBody
                      style={{
                        overflowY: "scroll",
                        height: `${window.innerHeight - 210}px`,
                        padding: "0",
                        overflowX: "hidden",
                        margin: 0,
                        //height: "650px",
                        //scrollbarStyles,
                      }}
                    >
                      {/* User and Document Type */}
                      <Row className="px-3">
                        <Col md={user && document ? 6 : 4}>
                          <div>
                            <FormGroupLabel>{t("user")}</FormGroupLabel>
                            <Controller
                              name="user"
                              control={control}
                              //errors={errors}
                              render={({ field: { onChange, value, ref } }) => (
                                <Select
                                  options={activeUsers}
                                  //value={vehicles.find((c) => c.value === value)}
                                  value={value}
                                  onChange={onChange}
                                  placeholder={t("user_placeholder")}
                                  styles={formStyles}
                                  isDisabled={type === "edit" || roleId === 4}
                                />
                              )}
                              rules={{ required: t("required_err") }}
                            />
                          </div>
                          {errors?.user && (
                            <Error error={errors.user.message} />
                          )}
                        </Col>
                        <Col md={user && document ? 6 : 4}>
                          <div>
                            <FormGroupLabel>{t("document")}</FormGroupLabel>
                            <Controller
                              name="document"
                              control={control}
                              errors={errors}
                              render={({ field: { onChange, value, ref } }) => (
                                <CreatableSelect
                                  options={docsList}
                                  //value={serviceTasks.find((c) => c.value === value)}
                                  value={value}
                                  onChange={(e) => {
                                    onChange(e);
                                    clearErrors("document");
                                  }}
                                  placeholder={t("select_or_create_doc")}
                                  styles={formStyles}
                                  isDisabled={user ? false : true}
                                  onCreateOption={handleCreateNewDoc}
                                  onCreateNew={() => {
                                    setShowCreateDocNamePopup(true);
                                  }}
                                  components={{
                                    //Option: SingleValueOption,
                                    MenuList: CustomMenuList,
                                  }}
                                  createNewLabel={t("create_new_doc")}
                                />
                              )}
                              rules={{ required: t("required_err") }}
                            />
                          </div>
                          {errors?.document && (
                            <Error error={errors.document.message} />
                          )}
                        </Col>
                      </Row>

                      {user && document && (
                        <>
                          <hr className="mt-4 mb-0" />
                          <Row className="px-3">
                            <Col md={6}>
                              <FormGroupLabel>
                                {t("expiry_date")}
                              </FormGroupLabel>
                              <Controller
                                name="expiryDate"
                                defaultValue={null}
                                control={control}
                                render={({
                                  field: { onChange, value, ref },
                                }) => (
                                  <DatePicker
                                    //minDate={new Date()}
                                    minDate={(() => {
                                      const tomorrow = new Date();
                                      tomorrow.setDate(tomorrow.getDate() + 1);
                                      return tomorrow;
                                    })()}
                                    selected={value}
                                    //onChange={onChange}
                                    onChange={(val) => {
                                      onChange(val);
                                      if (!val) {
                                        setValue("notifyMeDuration", "");
                                      }
                                    }}
                                    customInput={
                                      <CustomInput clearable={true} />
                                    }
                                    placeholderText={t("date_tv")}
                                    locale={getDateFnsLocale()}
                                    dateFormat={"P"}
                                    showMonthDropdown
                                    showYearDropdown
                                    isClearable
                                  />
                                )}
                                rules={{
                                  required: true,
                                  min: {
                                    value: new Date(),
                                    message: t(
                                      "exp_date_less_than_current_date_err_msg"
                                    ),
                                  },
                                }}
                              />

                              {errors?.expiryDate && (
                                <Error error={errors.expiryDate.message} />
                              )}
                            </Col>
                          </Row>

                          <hr className="mt-4 mb-0" />

                          {/* Notification Settings */}
                          <Row className="px-3 pt-3">
                            <div className="d-flex align-items-center">
                              <h5>{t("notification_settings")}</h5>
                              {tag === "free-user" && (
                                <div
                                  //className="mb-1"
                                  style={{ marginBottom: "0.1rem" }}
                                >
                                  <SubscribeTooltipIcon
                                    message={t("subscribe_msg")}
                                    handleClick={() =>
                                      setShowSubscribePopup(true)
                                    }
                                  />
                                </div>
                              )}
                            </div>

                            <Desc
                              style={{ paddingTop: "4px" }}
                              className="d-flex gap-1"
                            >
                              <span>{t("notifications_email_msg")}</span>
                              {tag === "free-user" && (
                                <span>{`(${t("paid_feature_str_sm")})`}</span>
                              )}
                            </Desc>

                            <FormGroupLabel>{t("notify_me")}</FormGroupLabel>
                            <Col md={6}>
                              <div>
                                <FormItem
                                  disabled={!expiryDate || tag === "free-user"}
                                >
                                  <FormField
                                    name="notifyMeDuration"
                                    control={control}
                                    component="input"
                                    type="number"
                                    onKeyDown={handleNegative}
                                    onWheel={
                                      handleNumberInputOnWheelPreventChange
                                    }
                                    errors={errors}
                                    disabled={
                                      !expiryDate || tag === "free-user"
                                    }
                                    rules={{
                                      min: {
                                        value: 1,
                                        message: t("greater_than_zero_err"),
                                      },
                                      // validate: {
                                      //   maxValue: (v) =>
                                      //     validateMaxNotifyMeOT(v) ||
                                      //     t("greater_than_expiry_err"),
                                      // },
                                    }}
                                    defaultValue=""
                                    //isAboveError={isAboveError}
                                    placeholder={t("duration")}
                                    style={formInputStyles}
                                  />
                                  <TimeSelect
                                    {...register("notifyMePeriod")}
                                    defaultValue="days"
                                    disabled={
                                      !expiryDate || tag === "free-user"
                                    }
                                    onClick={() => {
                                      setError("notifyMeDuration", {
                                        type: "maxValue",
                                      });
                                    }}
                                  >
                                    <option value="days">{t("days")}</option>
                                    <option value="weeks">{t("weeks")}</option>
                                    <option value="months">
                                      {t("months")}
                                    </option>
                                    <option value="years">{t("years")}</option>
                                  </TimeSelect>
                                </FormItem>
                              </div>
                              {errors?.notifyMeDuration && (
                                <Error
                                  error={errors.notifyMeDuration.message}
                                />
                              )}
                            </Col>
                            <Col
                              md={2}
                              className="d-flex justify-content-center align-items-center p-0 mx-3"
                            >
                              <span>{t("before_expiry_date")}</span>
                            </Col>
                          </Row>

                          <Row className="px-3">
                            <FormGroupLabel>
                              {t("send_notification_to")}
                              {/* <Tooltip text={t("premium_feature")}>
                            <DollarIcon className="fi fi-ss-usd-circle"></DollarIcon>
                          </Tooltip> */}
                            </FormGroupLabel>
                            <Col md={6}>
                              <Controller
                                name="userEmail"
                                control={control}
                                errors={errors}
                                render={({
                                  field: { onChange, value, ref },
                                }) => (
                                  <Select
                                    options={activeUsers}
                                    value={value}
                                    onChange={onChange}
                                    placeholder={t("noti_recipients")}
                                    styles={formStyles}
                                    isMulti
                                    closeMenuOnSelect={false}
                                    //hideSelectedOptions={false}
                                    // components={{
                                    //   Option,
                                    // }}
                                    isDisabled={tag === "free-user"}
                                  />
                                )}
                                // rules={{ required: true }}
                              />
                            </Col>
                          </Row>

                          <Row className="px-3 pb-3">
                            <Col>
                              <FormGroupLabel>
                                {t("notification_email_preview")}
                              </FormGroupLabel>
                              <Controller
                                name="notes"
                                control={control}
                                errors={errors}
                                render={({
                                  field: { onChange, value, ref },
                                }) => (
                                  <textarea
                                    rows={2}
                                    id="notes"
                                    name="notes"
                                    onChange={onChange}
                                    value={value}
                                    placeholder={t("email_preview_placeholder")}
                                    disabled={tag === "free-user"}
                                  ></textarea>
                                )}
                              />
                            </Col>
                          </Row>

                          {type === "edit" && expiryDate && (
                            <>
                              {/* <Row className="px-3"> */}
                              {/* <Col> */}
                              <hr className="mt-0" />
                              {/* </Col> */}
                              {/* </Row> */}

                              <Row className="px-3">
                                <Col>
                                  <FormHeading>
                                    {t("renewal_status")}
                                  </FormHeading>
                                </Col>
                              </Row>

                              <Row className="px-3 pb-3">
                                <Col>
                                  <div
                                    style={{
                                      border: `1px solid ${colorYellowNew}`,
                                      borderRadius: "5px",
                                      background: "#fffbeb",
                                    }}
                                    className="d-flex flex-column gap-1 p-3"
                                  >
                                    {new Date() > expiryDate && (
                                      <div className="d-flex gap-2 align-items-center">
                                        <i
                                          className="fi fi-rr-clock align-self-start"
                                          style={{
                                            position: "relative",
                                            top: "3px",
                                            color: "#f59e0b",
                                          }}
                                        ></i>
                                        {/* <div className="d-flex flex-column"> */}
                                        <p
                                          style={{
                                            color: "#92400e",
                                            fontSize: 16,
                                          }}
                                        >
                                          {t("renewal_pending")}
                                        </p>

                                        {/* </div> */}
                                      </div>
                                    )}

                                    <span
                                      style={{ color: "#b45309" }}
                                      className="mb-1"
                                    >{`${t(
                                      new Date() > expiryDate
                                        ? "doc_was_due_for_renewal_on_date"
                                        : "doc_needs_to_be_renewed_before_date",
                                      { date: convertToTextDate(expiryDate) }
                                    )}`}</span>

                                    <div style={{ maxWidth: "100px" }}>
                                      <GreenButton
                                        type="button"
                                        onClick={handleMarkAsRenewed}
                                      >
                                        {t("mark_as_renewed")}
                                      </GreenButton>
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            </>
                          )}
                        </>
                      )}
                    </CardBody>
                  </Card>
                </Col>

                {user && document && (
                  <Col md={4}>
                    <Card>
                      <CardBody>
                        <div>
                          <FormHeading>{t("reminder_preview")}</FormHeading>
                          {expiryDate && (
                            <div className="mb-3">
                              <h5 className="font-weight-bold font-size-14 py-2">
                                {t("doc_expires_on")}
                              </h5>
                              <DueOnWrap>
                                <span>{convertToTextDate(expiryDate)}</span>
                              </DueOnWrap>
                              {notifyMeDate && (
                                <NotifyMeWrap>
                                  <i className="fi fi-rr-clock"></i>
                                  <span>{convertToTextDate(notifyMeDate)}</span>
                                </NotifyMeWrap>
                              )}
                            </div>
                          )}

                          {document && document.url && (
                            <>
                              <h5>{t("doc_preview")}</h5>
                              <div
                                className="d-flex flex-column justify-content-center align-items-center p-2 my-2"
                                style={{
                                  border: `1px solid ${colorLightGray}`,
                                  borderRadius: "5px",
                                }}
                              >
                                {["png", "jpg", "jpeg", "jfif"].includes(
                                  document.url.split(".")?.pop()
                                ) ? (
                                  <img
                                    src={`${s3Url}/org_${user?.org_id}/${document.url}`}
                                    alt="doc-photo"
                                    width={300}
                                    height={150}
                                    id="doc"
                                    style={{ objectFit: "cover" }}
                                  />
                                ) : (
                                  <iframe
                                    src={`${s3Url}/org_${user?.org_id}/${document.url}`}
                                    alt="doc-photo"
                                    width={300}
                                    height={150}
                                    id="doc"
                                    //style={{ overflow: "hidden", height: "101%", width: "101%" }}
                                  />
                                )}
                                <HintText>{document.label}</HintText>
                                {expiryDate && (
                                  <HintText>{`${t(
                                    "expires"
                                  )}: ${convertToTextDate(
                                    expiryDate
                                  )}`}</HintText>
                                )}
                              </div>
                            </>
                          )}
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                )}
              </Row>
            </Container>
          </FormContainer>
        </Modal.Body>
        <Modal.Footer>
          <AddFormButton
            id="save-form-button"
            type="button"
            onClick={addReminder}
            disabled={!user || !document}
          >
            {saveBtnLoading ? <CustomLoader /> : t("save")}
          </AddFormButton>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DocumentRenewalsFormPopup;
